// extracted by mini-css-extract-plugin
module.exports = {"text":"PTag_text__meStA"};